import React, { FC, useContext } from 'react';

import { GlobalContext } from '../../../store';

import PlayerLookup from '../../../components/PlayerLookup/PlayerLookup';

interface IProps {
  clubId: string;
}

const ClubRoster: FC<IProps> = props => {
  const { clubs } = useContext(GlobalContext);

  const club = clubs[Number(props.clubId)];

  return (
    <div>
      <div className="club-roster">
        {club && (
          <PlayerLookup outlinedInput={true} players={club ? club.members : []} clubId={club.id} />
        )}
      </div>
    </div>
  );
};

export default ClubRoster;
